<template>
  <div class="container-fluid py-4">
    <div class="card shadow-sm p-4">
      <!-- Header -->
      <div class="row align-items-center mb-3">
        <div class="col-12 col-md-6">
          <h5 class="mb-0">
            <i class="fa fa-file-invoice me-2 text-primary"></i>
            Nueva Factura
          </h5>
          <small class="text-muted">Factura temporal #{{ facturaTempNumber }}</small>
        </div>
        <div class="col-12 col-md-2 text-md-end mt-3 mt-md-0">
          <argon-button class="btn btn-secondary w-100 w-md-auto" @click="goBack">
            <i class="fa fa-arrow-left me-1"></i> Volver
          </argon-button>
        </div>
        <div class="col-12 col-md-2 text-md-end mt-3 mt-md-0">
          <argon-button class="btn btn-success w-100 w-md-auto" @click="guardarFactura">
            <i class="fa fa-save me-1"></i> Guardar
          </argon-button>
        </div>
        <div class="col-12 col-md-2 text-md-end mt-3 mt-md-0">
          <argon-button class="btn btn-primary w-100 w-md-auto" @click="printPDF">
            <i class="fa fa-print me-1"></i> Imprimir
          </argon-button>
        </div>
      </div>
      <!-- Datos del cliente -->
      <div class="card bg-light border-0 mb-4 p-3">
        <div class="row g-3 align-items-end">
            <div class="col-md-6">
                <label class="form-label mb-1">Cliente</label>
                <select class="form-select" v-model="factura.cliente_id">
                <option disabled value="">Seleccione un cliente</option>
                <option v-for="cliente in clientes" :key="cliente.id" :value="cliente.id">
                    {{ cliente.nombre }} - {{ cliente.nit }}
                </option>
                </select>
            </div>
            <div class="col-md-3">
                <label class="form-label mb-1">Fecha</label>
                <input type="date" class="form-control" v-model="factura.fecha" />
            </div>
            <div class="col-md-3">
                <label class="form-label text-sm">Tipo de documento</label>
                <select v-model="factura.header.invoice_type" class="form-select">
                    <option value="FACTURA">Factura</option>
                    <option value="TICKET">Ticket</option>
                </select>
            </div>
        </div>
      </div>

      <!-- Agregar productos -->
      <div class="card border mb-4 p-3">
        <div class="row g-3 align-items-end">
          <div class="col-md-5">
            <label class="form-label mb-1">Producto</label>
            <select class="form-select" v-model="productoSeleccionado">
              <option disabled value="">Seleccione producto</option>
              <option v-for="p in productos" :key="p.id" :value="p">
                {{ p.nombre }} - ${{ p.precio_venta }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1">Cantidad</label>
            <input type="number" min="1" class="form-control" v-model.number="cantidad" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1">Precio</label>
            <input type="number" step="0.01" class="form-control" v-model.number="precio" />
          </div>
          <div class="col-md-2 text-md-end mt-3 mt-md-0">
            <argon-button class="btn btn-primary w-100 w-md-auto" @click="agregarProducto">
              <i class="fa fa-plus me-1"></i> Agregar
            </argon-button>
          </div>
        </div>
      </div>

      <!-- Tabla detalle -->
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Producto</th>
              <th class="text-center">Cant.</th>
              <th class="text-end">Precio</th>
              <th class="text-end">Subtotal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in factura.lines" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.nombre }}</td>
              <td class="text-center">{{ item.cantidad }}</td>
              <td class="text-end">${{ Number(item.precio).toFixed(2) }}</td>
              <td class="text-end">${{ (item.cantidad * item.precio).toFixed(2) }}</td>
              <td class="text-end">
                <button class="btn btn-sm btn-danger" @click="eliminarProducto(index)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="factura.lines.length === 0">
              <td colspan="6" class="text-center text-muted">No hay productos agregados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Totales -->
      <div class="d-flex justify-content-end mt-3">
        <div class="text-end">
          <p class="mb-1"><strong>Subtotal:</strong> ${{ subtotal.toFixed(2) }}</p>
          <p class="mb-1"><strong>IVA (13%):</strong> ${{ iva.toFixed(2) }}</p>
          <h5 class="mb-0"><strong>Total:</strong> ${{ total.toFixed(2) }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  name: "CrearFactura",
  components: { ArgonButton },
  data() {
    return {
      facturaTempNumber: "0001-000000123",
      clientes: [
        { id: 1, nombre: "Juan Pérez", nit: "0614-123456-001-1", direccion: "San Salvador" },
        { id: 2, nombre: "María López", nit: "0614-654321-002-2", direccion: "Santa Tecla" },
      ],
      productos: [
        { id: 4, nombre: "Chuleta de Cerdo Criolla (Lb)", precio_venta: 3.25 },
        { id: 5, nombre: "Lomo de Cerdo Fresco (Lb)", precio_venta: 3.35 },
        { id: 6, nombre: "Costilla Riblets (Lb)", precio_venta: 2.45 },
        { id: 7, nombre: "Carne Molida de Cerdo Especial (Lb)", precio_venta: 2.59 },
        { id: 8, nombre: "Posta de Cerdo (Lb)", precio_venta: 3.20 },
        { id: 9, nombre: "Tocino Ahumado (Paq. 170g)", precio_venta: 3.98 },
        { id: 10, nombre: "Carnitas para Chicharrón (Lb)", precio_venta: 2.85 },
        { id: 11, nombre: "Hueso de Cerdo (Lb)", precio_venta: 1.07 },
      ],
      factura: {
        cliente_id: "",
        fecha: new Date().toISOString().split("T")[0],
        lines: [],
        header:{
          emitter_nit: "12345678-9",
          emitter_name: "Mi Empresa POS",
          invoice_type:"FACTURA",
          currency: "USD",
          state: "EMITTED",
          full_number: null,
          date_issued: null,
          subtotal: 0,
          total_taxes: 0,
          total: 0
        }
      },
      productoSeleccionado: null,
      cantidad: 1,
      precio: 0,
    };
  },
  watch: {
    productoSeleccionado(newVal) {
      // auto llenar precio al seleccionar producto
      if (newVal) {
        this.precio = Number(newVal.precio_venta) || 0;
      } else {
        this.precio = 0;
      }
    }
  },
  computed: {
    subtotal() {
      return this.factura.lines.reduce((sum, i) => sum + Number(i.cantidad) * Number(i.precio), 0);
    },
    iva() {
      return this.subtotal * 0.13;
    },
    total() {
      return this.subtotal + this.iva;
    },
  },
  methods: {
    agregarProducto() {
      if (!this.productoSeleccionado) return alert("Seleccione un producto");
      if (!this.cantidad || this.cantidad <= 0) return alert("Ingrese una cantidad válida");

      const precioFinal = (this.precio && Number(this.precio) > 0) ? Number(this.precio) : Number(this.productoSeleccionado.precio_venta);

      const item = {
        id: this.productoSeleccionado.id,
        nombre: this.productoSeleccionado.nombre,
        cantidad: Number(this.cantidad),
        precio: Number(precioFinal),
        tax_rate: 0, // si querés manejar impuestos por línea, ajustar aquí
      };

      this.factura.lines.push(item);

      // limpiar inputs
      this.productoSeleccionado = null;
      this.cantidad = 1;
      this.precio = 0;
    },
    eliminarProducto(index) {
      this.factura.lines.splice(index, 1);
    },
    guardarFactura() {
      // actualizar encabezado con totales y otros campos
      this.factura.header.subtotal = this.subtotal;
      this.factura.header.total_taxes = this.iva;
      this.factura.header.total = this.total;
      this.factura.header.full_number = this.factura.header.full_number || this.facturaTempNumber;
      this.factura.header.date_issued = this.factura.header.date_issued || this.factura.fecha;
      alert("Factura guardada correctamente (simulada)");
      // si querés imprimir automáticamente:
      // this.printPDF();
    },
    printPDF() {
      // sincronizar header con cálculos
      const cliente = this.clientes.find(c => c.id === this.factura.cliente_id);
      this.factura.header.client_name = cliente ? cliente.nombre : '';
      this.factura.header.client_nit = cliente ? cliente.nit : '';
      this.factura.header.subtotal = this.subtotal;
      this.factura.header.total_taxes = this.iva;
      this.factura.header.total = this.total;
      this.factura.header.full_number = this.factura.header.full_number || this.facturaTempNumber;
      this.factura.header.date_issued = this.factura.header.date_issued || this.factura.fecha;

      if (!this.factura) {
        alert('No hay datos de factura para imprimir.');
        return;
      }

      const doc = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: [80,200]
      });

      const marginLeft = 1;
      const marginTop = 5;
      const pageWidth = doc.internal.pageSize.getWidth();
      //const availableWidth = pageWidth - marginLeft * 2;

      doc.setFontSize(8);

      // === HEADER DE EMPRESA ===
      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.text(this.factura.header.emitter_name, pageWidth / 2, marginTop, { align: 'center' });
      doc.setFontSize(7);
      doc.setFont(undefined, 'normal');
      doc.text(`NIT: ${this.factura.header.emitter_nit}`, pageWidth / 2, marginTop + 5, { align: 'center' });

      doc.setLineWidth(0.5);
      doc.line(marginLeft, marginTop + 10, pageWidth - marginLeft, marginTop + 10);

      let yPosition = marginTop + 15;

      // === INFO FACTURA ===
      doc.setFontSize(9);
      doc.setFont(undefined, 'bold');
      doc.text(`Factura: ${this.factura.header.full_number}`, marginLeft, yPosition);
      yPosition += 8;

      doc.setFontSize(7);
      doc.setFont(undefined, 'normal');
      doc.text(`Cliente: ${this.factura.header.client_name}`, marginLeft, yPosition);
      doc.text(`NIT: ${this.factura.header.client_nit}`, marginLeft, yPosition + 4);
      doc.text(`Fecha: ${this.formatDate(this.factura.header.date_issued || this.factura.fecha)}`, marginLeft, yPosition + 8);

      // Datos a la derecha
      doc.text(
          `Tipo: ${this.factura.header.invoice_type === 'FACTURA' ? 'Factura' : 'Ticket'}`,
          pageWidth - marginLeft,
          yPosition,
          { align: 'right' }
      );
      doc.text(`Estado: ${this.getStateText(this.factura.header.state)}`, pageWidth - marginLeft, yPosition + 4, { align: 'right' });
      doc.text(`Moneda: ${this.factura.header.currency}`, pageWidth - marginLeft, yPosition + 8, { align: 'right' });

      yPosition += 15;

      // === TABLA DETALLE ===
      const tableData = this.factura.lines.map(line => {
        const lineTotal = Number(line.cantidad) * Number(line.precio);
        return [
          line.nombre,
          Number(line.cantidad).toFixed(2),
          `$${Number(line.precio).toFixed(2)}`,
          `${line.tax_rate || 0}%`,
          `$${lineTotal.toFixed(2)}`
        ];
      });

      autoTable(doc, {
          head: [['Descripción', 'Cant.', 'P/U', 'Imp.', 'Total']],
          body: tableData,
          startY: yPosition,
          theme: 'grid',
          styles: {
          fontSize: 7,
          cellPadding: 1,
          overflow: 'linebreak',

          },
          headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          fontSize: 7
          },
          columnStyles: {
          0: { cellWidth: 35},
          1: { cellWidth: 10, halign: 'center' },
          2: { cellWidth: 12, halign: 'right' },
          3: { cellWidth: 8, halign: 'center' },
          4: { cellWidth: 15, halign: 'right' }
          },
          margin: { left: marginLeft, right: marginLeft }
      });

      // === TOTALES ===
      let finalY = (doc.lastAutoTable && doc.lastAutoTable.finalY ? doc.lastAutoTable.finalY : yPosition) + 8;
      doc.setFontSize(9);
      doc.setFont(undefined, 'bold');
      doc.text('Totales', marginLeft, finalY);

      doc.setFontSize(8);
      doc.setFont(undefined, 'normal');
      finalY += 5;
      doc.text(`Subtotal: $${this.factura.header.subtotal.toFixed(2)}`, pageWidth - marginLeft, finalY, { align: 'right' });
      finalY += 5;
      doc.text(`Impuestos: $${this.factura.header.total_taxes.toFixed(2)}`, pageWidth - marginLeft, finalY, { align: 'right' });
      finalY += 5;
      doc.setFont(undefined, 'bold');
      doc.text(`Total: $${this.factura.header.total.toFixed(2)}`, pageWidth - marginLeft, finalY, { align: 'right' });

      // Línea separadora
      finalY += 8;
      doc.setLineWidth(0.3);
      doc.line(marginLeft, finalY, pageWidth - marginLeft, finalY);

      // === PIE / FIRMA ===
      finalY += 10;
      doc.setFontSize(6);
      doc.text(
          'Gracias por su compra.',
          pageWidth / 2,
          finalY,
          { align: 'center' }
      );
      finalY += 5;
      doc.text(
          'Esta factura cumple con los requisitos del Ministerio de Hacienda de El Salvador.',
          pageWidth / 2,
          finalY,
          { align: 'center' }
      );
      finalY += 5;
      doc.text(
          'Documento generado electrónicamente. No requiere firma autógrafa.',
          pageWidth / 2,
          finalY,
          { align: 'center' }
      );

      window.open(doc.output('bloburl'), '_blank');
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString('es-ES', { 
          day: '2-digit', 
          month: '2-digit', 
          year: 'numeric', 
          hour: '2-digit', 
          minute: '2-digit' 
      });
    },
    getStateClass(state) {
      return state === 'EMITTED' ? 'text-warning' : state === 'PAID' ? 'text-success' : 'text-danger';
    },
    getStateText(state) {
      return state === 'EMITTED' ? 'Emitida' : state === 'PAID' ? 'Pagada' : 'Cancelada';
    },
    goBack() {
      this.$router.push("/invoices");
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 1rem;
}
.table th,
.table td {
  vertical-align: middle;
}
.table input {
  border: none;
  border-bottom: 1px solid #dee2e6;
  border-radius: 0;
}
</style>
